<template>
  <EditDialog
    v-model:visible="showModal"
    :title="
      $t('views.layout.Dialog.CancelAccount.91e103f2a0b71da53dc63cf7f8efa2f6')
    "
    :width="625"
    :mask-closable="false"
    is-show-cancel
    :padding="30"
    hide-footer
  >
    <div class="dialog-body">
      <div class="mb10">
        {{
          $t(
            'views.layout.Dialog.CancelAccount.8f12fcf472b3e0d8aef0db67bea36f1d'
          )
        }}
      </div>
      <DynamicsForm
        :model="formModel"
        :setting="feedbackSetting"
        :label-width="110"
        layout="labelTop"
        :group-collapse="false"
        tips-placement="left"
      />
      <div v-if="IS_DOMESTIC" class="feedback-info mb16">
        <div class="feedback-info-item">
          <span>{{
            $t(
              'views.layout.Dialog.CancelAccount.038235a36c3418bd90e9cb505c92dced'
            )
          }}</span>
          <span>rc_agentos@brgroup.com</span>
        </div>
        <div class="feedback-info-item">
          <span>{{
            $t(
              'views.layout.Dialog.CancelAccount.576cfe972833056f3b310a8feffab5f6'
            )
          }}</span>
          <span class="mr12">400-008-8182</span>
          <span>010-64718828</span>
        </div>
      </div>
      <div v-if="!IS_DOMESTIC" class="mb16">
        <span class="mr4">{{
          $t(
            'views.layout.Dialog.CancelAccount.038235a36c3418bd90e9cb505c92dced'
          )
        }}</span>
        <span class="mr12">agents-service@dyna.ai</span>
        <span>support@dyna.ai</span>
      </div>
      <div class="content-btn">
        <u-button
          type="primary"
          class="feedback-btn"
          style="margin: 0 8px"
          data-testid="submit-account-feedback-button"
          @click="handleSubmit"
        >
          {{
            $t(
              'views.layout.Dialog.CancelAccount.f15c9e0720c9a90b8afd01f8235b442e'
            )
          }}
        </u-button>

        <u-button
          type="primary"
          class="feedback-btn"
          style="margin: 0 8px"
          data-testid="open-cancel-account-confirmation-button"
          @click="handleCancel"
        >
          <span class="content-text">{{
            $t(
              'views.layout.Dialog.CancelAccount.100e4ab68d862074526701683d129385'
            )
          }}</span>
        </u-button>
      </div>
    </div>
  </EditDialog>
  <SureCancel ref="sureCancel" @submit="handleCancelAccount" />
</template>

<script>
import { useI18n } from 'vue-i18n';
import { defineComponent, ref } from 'vue';
import { DynamicsForm } from '@koi-design/vix-components';
import { message } from '@koi-design/uxd-ui';
import { feedBackApi } from '@api/common';
import { cancelAccountApi } from '@api/permission';
import SureCancel from './SureCancel.vue';
import { notifyAccountStatusChange } from '@/libs/accountSync';

export default defineComponent({
  name: 'CreateDataSet',
  components: {
    DynamicsForm,
    SureCancel
  },
  emits: ['success'],
  setup() {
    const { t } = useI18n();
    const showModal = ref(false);
    const formModel = ref({
      content: '',
      contact_information: '',
      feedback_source: '3'
    });
    const show = (flag = true) => {
      formModel.value = {
        content: '',
        contact_information: '',
        feedback_source: '3'
      };
      showModal.value = flag;
    };
    const feedbackSetting = [
      {
        label: t(
          'views.layout.Dialog.CancelAccount.3eb57d347309a509743d81054249cd96'
        ),
        name: 'content',
        type: 'textarea',
        props: {
          maxlength: 2000,
          showWordLimit: true,
          placeholder: t(
            'views.layout.Dialog.CancelAccount.169cd7fc539e30ef748181ce7e9755eb'
          ),
          style: 'height: 120px'
        }
      },
      {
        label: t(
          'views.layout.Dialog.CancelAccount.3058946199708a721d3632097b971857'
        ),
        type: 'input',
        name: 'contact_information',
        props: {
          maxlength: 100,
          placeholder: t(
            'views.layout.Dialog.CancelAccount.904dfc805556694354f4019b6f85214e'
          )
        }
      }
    ];
    const handleSubmit = async () => {
      if (!formModel.value.content.trim()) {
        message.error(
          t(
            'views.layout.Dialog.CancelAccount.e785f47d6a43b0c8091eb7b6536ba926'
          )
        );
        return;
      }
      const res = await feedBackApi({
        ...formModel.value
      });
      if (res) {
        showModal.value = false;
      }
      showModal.value = false;
    };
    const sureCancel = ref(null);
    const handleCancel = () => {
      if (!formModel.value.content.trim()) {
        message.error(
          t(
            'views.layout.Dialog.CancelAccount.e785f47d6a43b0c8091eb7b6536ba926'
          )
        );
        return;
      }
      sureCancel.value.show();
    };
    const handleCancelAccount = async () => {
      const res = await cancelAccountApi();
      if (res) {
        notifyAccountStatusChange('logout');
        localStorage.removeItem('sbtToken');
        localStorage.removeItem('sessionId');
        localStorage.removeItem('auth_provider');
        localStorage.removeItem('azure_token_created_time');
        window.location.href = '/login';
      }
    };
    return {
      showModal,
      show,
      formModel,
      feedbackSetting,
      handleSubmit,
      handleCancel,
      sureCancel,
      handleCancelAccount
    };
  }
});
</script>

<style scoped lang="less">
.feedback-btn {
  position: relative;
  --button-padding-base: 12px;
  --button-height-base: 32px;
}
.w-h {
  visibility: hidden;
}

.content-btn {
  display: flex;
  justify-content: center;
  margin-bottom: 40px;
}
.feedback-info {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  .feedback-info-item {
    display: flex;
  }
}
</style>
